import { render, staticRenderFns } from "./DosagePopin.vue?vue&type=template&id=68144c7e"
import script from "./DosagePopin.vue?vue&type=script&lang=js"
export * from "./DosagePopin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68144c7e')) {
      api.createRecord('68144c7e', component.options)
    } else {
      api.reload('68144c7e', component.options)
    }
    module.hot.accept("./DosagePopin.vue?vue&type=template&id=68144c7e", function () {
      api.rerender('68144c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/appellation/DosagePopin.vue"
export default component.exports